import * as Yup from 'yup';

import { assigneeIdValidation } from '../fields/AssigneeIdField';
import { classificationIdValidation } from '../fields/ClassificationIdField';
import { descriptionValidation } from '../fields/DescriptionField';
import { impactedUserIdsValidation } from '../fields/ImpactedUserIdsField';
import { incidentDateValidation } from '../fields/IncidentDateField';
import { kustomerUrlValidation } from '../fields/KustomerUrlField';
import { offenderIdValidation } from '../fields/OffenderIdField';
import { offenderTypeValidation } from '../fields/OffenderTypeField';
import { reportedOnValidation } from '../fields/ReportedOnField';
import { tripIdValidation } from '../fields/TripIdField';

export const addIncidentValidationSchema = Yup.object().shape({
  reportedOn: reportedOnValidation,
  kustomerUrl: kustomerUrlValidation,
  assigneeId: assigneeIdValidation,
  offenderType: offenderTypeValidation,
  description: descriptionValidation,
  classificationId: classificationIdValidation,
  tripId: tripIdValidation,
  incidentDate: incidentDateValidation,
  offenderId: offenderIdValidation,
  impactedUserIds: impactedUserIdsValidation,
});
